export const ADD_TO_PRESENTATION = 'Add to presentation';
export const WILDCARD = '*';
